// AiFeedService.js

import { httpsCallable } from 'firebase/functions';

import { functions } from 'firebaseConfig';
import { resolveClientTimeZone } from 'spaces/utils/scheduleWindow';
import { buildTenantCallableFields } from 'utilities/basePersistence';

const aiFeedDigestCallable = httpsCallable(functions, 'aiFeedDigest');

export async function requestAiFeedDigest({
  baseKey,
  sinceMs = null,
  timeZone = null,
} = {}) {
  const cleanBaseKey = String(baseKey || '').trim();
  if (!cleanBaseKey) return null;

  const response = await aiFeedDigestCallable({
    ...buildTenantCallableFields(cleanBaseKey),
    sinceMs: sinceMs || undefined,
    timeZone: timeZone || resolveClientTimeZone(),
  });

  return response?.data || null;
}
